/**
 * @generated SignedSource<<7f108e8ad0758e4b5fe4964d8d84129e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type ProfilePlatform = "FACEBOOK" | "INSTAGRAM" | "LUMINATE" | "SOUNDCLOUD" | "SPOTIFY" | "TIKTOK" | "TWITTER" | "YOUTUBE";
import { FragmentRefs } from "relay-runtime";
export type ArtistEditSocialLinks_artist$data = {
  readonly id: string;
  readonly profiles: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly platform: ProfilePlatform;
        readonly url: string | null;
      } | null;
    } | null>;
  };
  readonly " $fragmentType": "ArtistEditSocialLinks_artist";
};
export type ArtistEditSocialLinks_artist$key = {
  readonly " $data"?: ArtistEditSocialLinks_artist$data;
  readonly " $fragmentSpreads": FragmentRefs<"ArtistEditSocialLinks_artist">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ArtistEditSocialLinks_artist",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "ProfileNodeConnection",
      "kind": "LinkedField",
      "name": "profiles",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ProfileNodeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ProfileNode",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "url",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "platform",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ArtistNode",
  "abstractKey": null
};
})();

(node as any).hash = "fbddf816f8066968367867563e17f298";

export default node;
